import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchmultilevelApproval = () => {
  return apiClient(ENDPOINTS.MULTILEVELAPPROVAL, {
    method: "GET",
  });
};

export const createMultilevelApproval = (multilevelData) => {
  return apiClient(ENDPOINTS.MULTILEVELAPPROVAL, {
    method: "POST",
    body: multilevelData,
  });
};

export const createMultiLevelApproval = (payload) => {
  return apiClient(ENDPOINTS.MULTILEVELAPPROVAL, {
    method: "POST",
    body: payload,
  });
};

export const updateMultiLevelApproval = (id, payload) => {
  return apiClient(ENDPOINTS.MULTILEVELAPPROVAL_BY_ID(id), {
    method: "PUT",
    body: payload,
  });
};

export const deleteMultiLevelApproval = (id) => {
  return apiClient(ENDPOINTS.MULTILEVELAPPROVAL_BY_ID(id), {
    method: "DELETE",
  });
};

export const fetchUserGeoMapping = (userId) => {
  return apiClient(ENDPOINTS.USER_GEO_MAPPING(userId), {
    method: "GET",
  });
};
